"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _nuiWidgets = require("@concur/nui-widgets");

var _reactLoader = _interopRequireDefault(require("react-loader"));

var _nuiIntl = require("@concur/nui-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var spinnerOpts = {
  lines: 8,
  length: 1,
  width: 14,
  radius: 32,
  scale: 1,
  corners: 3,
  color: '#2379BF',
  opacity: 0.25,
  rotate: 0,
  direction: 1,
  speed: 1,
  trail: 60,
  fps: 20,
  zIndex: 2e9,
  className: 'spinner',
  top: '300px',
  left: '50%',
  shadow: false,
  hwaccel: false,
  height: '300px'
};

var LoadingIndicator = function LoadingIndicator(_ref) {
  var isLoaded = _ref.isLoaded,
      children = _ref.children,
      beta = _ref.beta,
      props = _objectWithoutProperties(_ref, ["isLoaded", "children", "beta"]);

  if (beta) {
    var formatter = props.formatter;
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_nuiWidgets.Spinner, {
      visible: !isLoaded,
      size: "lg",
      id: "spinner",
      type: "block",
      message: formatter.formattedMessage('Loading')
    }), isLoaded && children);
  } else {
    return _react.default.createElement(_reactLoader.default, {
      loaded: isLoaded,
      options: spinnerOpts
    }, children);
  }
};

LoadingIndicator.propTypes = {
  isLoaded: _propTypes.default.bool.isRequired,
  children: _propTypes.default.any
};

var _default = (0, _nuiIntl.withFormatter)(LoadingIndicator);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/LoadingIndicator.js
// module id = 76
// module chunks = 0